import { FC, useEffect, useState } from "react";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useRouter } from "next/router";
import { SearchInput as UISearchInput } from "@Components/ui/search-input";
import { keywordSearchEvent } from "@Libs/dynamic-yield/trackingEvents";
import { nextAppEnv } from "@Utils/environment";
import { isCanadianLocale } from "@Utils/locale";
import { useAppSelector } from "@wff/store/hooks";
import { localeSelector } from "@wff/store/localeSlice";
import SearchInputPredict from "./SearchInputPredict";
import SearchInputPredictForCA from "./SearchInputPredictCA";
import classes from "./SearchInput.module.scss";

export const AUTOCOMPLETE_RESULT = "autocomplete-result";
export const CONTAINER_RESULTS = "container-autocomplete-results";

interface Props {}
const isAdvanceSearchFeatureEnabled =
  nextAppEnv.feature_toggle.CA.advanceSearch === "true";

export const SearchInput: FC<Props> = ({}) => {
  const { languageCode } = useAppSelector(localeSelector);
  const router = useRouter();
  const [focused, setFocused] = useState(false);
  const onFocus = () => setFocused(true);
  const onBlur = () => setFocused(false);
  const [term, setTerm] = useState("");
  const currentLocale = useAppSelector(localeSelector);
  const isCanadianUser = isCanadianLocale(currentLocale);
  const isMobile = useMediaQuery("(max-width:48em)");
  const { query } = router;
  const parsedSearchQuery =
    isCanadianUser && isMobile && !term ? (query?.q as string) : "";

  // TODO: From Daniel
  // Refactor this useEffect with a proper memoization technique
  useEffect(() => {
    if (parsedSearchQuery) {
      setTerm(parsedSearchQuery);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isCanadianUser, isMobile]);

  const onBlurHandler = () => {
    setTimeout(() => {
      onBlur();
    }, 150);
  };

  const setTermHandler = (term: string) => {
    if (!focused) {
      setFocused(true);
    }

    setTerm(term);
  };

  const onSearchTerm = (selectedTerm?: string) => {
    setFocused(false);
    const searchTerm = selectedTerm || term;

    /**
     * If user enteres empty string, Algolia search will not calls
     */
    if (!searchTerm?.trim()) {
      return;
    }

    setTermHandler(searchTerm);
    keywordSearchEvent(searchTerm); // Track `Keyword Search` Event for DY

    const searchTermBeef = searchTerm.toLocaleLowerCase();
    if (searchTermBeef === "beef") {
      router.push(`/${languageCode}/collections/` + searchTermBeef);
      return;
    }
    router.push(
      "/[locale]/search/?q=" + searchTerm,
      `/${languageCode}/search/?q=` + searchTerm
    );
  };

  const onKeyPressHandler = (key: string) => {
    if (key === "Enter") {
      onSearchTerm();
    } else if (key === "Escape") {
      setFocused(false);
    }
  };

  return (
    <div className={classes["autocomplete-container"]}>
      {" "}
      <UISearchInput
        value={term}
        onFocus={onFocus}
        placeholder="Search"
        onBlur={onBlurHandler}
        onChange={(e) => setTermHandler(e.target.value)}
        onKeyDown={(e) => onKeyPressHandler(e.key)}
        onMagnifierClickSearch={onSearchTerm}
      />
      {!isCanadianUser && !isAdvanceSearchFeatureEnabled ? (
        <SearchInputPredict
          term={term}
          focused={focused}
          onSuggestionClick={onSearchTerm}
        />
      ) : (
        <SearchInputPredictForCA
          term={term}
          focused={focused}
          onSuggestionClick={onSearchTerm}
        />
      )}
    </div>
  );
};
